import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import StudioHeader from './StudioHeader';
import StudioMain from './StudioMain';
import StudioLibrary from './library/StudioLibrary';
import UploadsProgressContainer from '../../common/uploadsProgress/uploadsProgressContainer';
import {customEvent} from '../../../utils/analyticsUtil';
import {DialogTypes, events} from '../../../constants/enums';
import StudioAbilities from './StudioAbilities';
import '../studio.scss';
import {getUserProperties} from "../../../utils/userUtility";

@inject('projectStore', 'dialogStore')
@observer
class StudioMobileContainer extends Component {
    componentDidMount() {
        if (!getUserProperties().studioAbilities) {
            this.props.dialogStore.openDialog(DialogTypes.StudioAbilities);
        }
    }
    render() {
        const {onExitCreateMode, projectStore, isDisabledSave, isReadOnly} = this.props;

        return (
            <div className="m-studio-container">
                <StudioHeader
                    isDisabledSave={isDisabledSave}
                    onSave={projectStore.handleProjectSave}
                    onExitCreateMode={onExitCreateMode} />
                <StudioMain isReadOnly={isReadOnly}/>
                <StudioLibrary/>
                <StudioAbilities/>
                <UploadsProgressContainer/>
            </div>
        );
    }
}

export default StudioMobileContainer;
